import http from "@/api/api"
import store from "@/store/index"

//获取代办事项
export const getAgent = async (vm) => {

    let res = await http.get(`/tenant/home/todo`);
    if(res?.data?.info?.length > 0){
        store.commit('upAgent_info', res.data);//存到vuex,更新代办
    }
    console.log(res,'侧边栏信息');
    return res.data ?? {};
}



